/* eslint-disable react-hooks/exhaustive-deps */

import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { withStyles } from '@material-ui/core';

import { Box, Button, Card, CardContent, Grid, Paper, Tooltip, Typography } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Spinner from 'modules/common/spinner.component';
import classNames from 'classnames';

import {
  //GET_AUTH_DESTINATION_SERVICES_FAILURE,
  UPDATE_AUTH_DESTINATION_SERVICES_BUYER_FAILURE
} from 'modules/authorizations/store/types/destinationServiceTypes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  deleteAuthDestinationTripsBuyer,
  deleteOfferHistoryList,
  getAuthDestinationServices,
  getOfferHistoryList,
  postOfferHistoryList,
  updateAuthDestinationServicesBuyer,
  updateAuthDestinationTripsBuyer,
  updateOfferHistoryList
} from 'modules/authorizations/store/actions/destinationService.actions';
import {
  getAuthDateSummary,
  getAuthorizationSummary,
  setAuthId,
  setLoadingComplete,
  getAuthorizationSummaryAddress
} from 'modules/authorizations/store/actions/authorizations.actions';
import { getBrokerAgents, getBrokerAgentsById } from 'modules/authorizations/store/actions/dataManagement.actions';
import { getAddress } from 'modules/authorizations/store/actions/authorizations.actions';

import { CreateVendorRelationshipList, formatTripAddress } from 'modules/authorizations/utils';
// import { setStatusTypes } from '../../utils';
import CrudTable from 'modules/clients/details/crudTable.component';
// import DestinationServicesStatusStepper from './destinationServicesStatusStepper.component';
import EditableCard from 'modules/common/editableCard.component';
import ServiceTriggeredComment from '../commentsAndNotes/serviceTriggeredComment.component';
import SlidingCommentsAndNotes from '../commentsAndNotes/commentsAndNotesSlidingPanel.component';
import HouseHuntingTripCard from './houseHuntingTripSummary.component';
import { showToast } from 'modules/layout/layout.actions';
import { SERVICE_IDS } from 'modules/enumerations/enumerationIds';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import SpinnerComponent from 'modules/common/spinner.component';
import BuyerPreferencesCard from './buyerPreferencesCard.component';
import { ZERO_GUID } from './destinationServicesDetailsEditableCard.component';
import CreateTripCard from 'modules/common/createAuthTripModal.component';
import StatusMenu from 'modules/common/statusMenu.component';
import { getServiceStatusDates } from 'modules/authorizations/store/actions/authorizations.actions';
import { GET_SERVICE_STATUS_DATES_FAILURE } from 'modules/authorizations/store/types/authorizationTypes';
import AuthServiceCancellationToggleButton from 'modules/common/authServiceCancellationToggleButton.component';
import AuthServiceGlobalEmailCardComponent from 'modules/emailTemplates/authEmailTemplates/authServiceGlobalEmailCard.component';
import AuthServiceHoldToggleButton from 'modules/common/authServiceHoldToggleButton.component';
import { formatMoney } from 'utilities/currencyFormatter';
import EstimatedDatesCard from './destinationServicesEstimatedDates.component';


const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  },
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  chipClickable: {
    cursor: 'pointer'
  },
  iconOverlayImg: {
    position: 'absolute'
  },
  spacingX: {
    marginRight: theme.spacing(1)
  },
  footer: {
    height: 15,
    marginBottom: theme.spacing(2)
  },
  mb2: {
    marginBottom: '4px',
    marginRight: '16px'
  },
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important'
  },
  editModalInput: {
    minWidth: '332px'
  },
  dialogContentContainer: {
    margin: '15px'
  },
  labelText: {
    minWidth: 350,
    marginBottom: 0
  }
});

const HOME_FINDING_TRIP_CATEGORY_ID = 'c0041355-c75d-4a0c-b2a9-69baf891e0d5';

export const toNumber = v => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

// Same formula as the API (DestinationRepository.CalculateExpectedReferralAmount): the offer amount times the agent's
// commission %, times the referral % of that commission. Null until all three are filled in with numbers.
const calculateExpectedReferralAmount = ({ offerAmount, referralPercentage, agentCommissionPercentage }) => {
  const [amount, referral, commission] = [offerAmount, referralPercentage, agentCommissionPercentage].map(value =>
    value === null || value === undefined || String(value).trim() === '' ? NaN : Number(value)
  );
  if (![amount, referral, commission].every(Number.isFinite)) return null;

  return Math.round(amount * (referral / 100) * (commission / 100) * 100) / 100;
};

// const createAddressName = address => (!address ? '' : [address.addressLineOne, address.city, address.state].filter(Boolean).join(', '));

const BuyerServices = props => {
  const {
    brokerAgents,
    id,
    details,
    location,
    isReadOnly,
    // addresses,
    emailTemplates,
    vendors,
    enumerations,
    clientInfo,
    mortgageLead,
    updateMortgageLeads,
    sendMortgageLeads
  } = props;

  const [statuses, setStatuses] = useState(
    details?.serviceStatusDates ? details.serviceStatusDates.filter(s => s.serviceType === 'Buyer') : []
  );

  const vendorsPreferredVendorSorted = CreateVendorRelationshipList(vendors, clientInfo?.clientDetails.clientVendorRelationships);

  const fileServices = details?.services
    ? details.services.find(fs => fs.authorizationFileServiceTypeId === '007e4298-676f-4e50-8791-fa6464cd5358')
    : [];
  const familyMembers = details?.familyMembers || [];
  const destinationInfo = details?.destinationServices || {};
  const buyer = destinationInfo?.destinationBuyerInfo || {};
  const mortgageLeadInfo = mortgageLead ? mortgageLead?.mortgageLead || {} : {};
  const selectedMortgageLeads = mortgageLead ? mortgageLead?.selectedMortgageLeads || [] : [];
  const isNewMortgageLeadRecord = !mortgageLeadInfo?.mortgageLeadId;
  const type = 'Buyer';

  const hasClosedOffer = destinationInfo?.hasClosedOffer ?? false;

  // const renterId = renter?.renter?.renterServiceId;
  const buyerId = buyer?.buyerServiceId;

  const addressOptions =
    details?.addresses && details?.addresses.length > 0
      ? details?.addresses.map(a => {
        const addressLabel = formatTripAddress(a, enumerations?.provinces, enumerations?.countries);
        return { ...a, id: a.addressId, title: addressLabel, description: addressLabel };
      })
      : [];

  const buyerTrips = destinationInfo?.buyerTrips || [];

  const createDestBuyerTemplates = () => {
    if (!emailTemplates || emailTemplates.length === 0) return [];

    const destTrips = emailTemplates.filter(
      t => isIdEqual(t.serviceId, SERVICE_IDS.DESTINATION_BUYER_SERVICE_ID) && t.containsDestinationTrip === true
      // t.containsDestination === true
    );

    // const destTripOnly = emailTemplates.filter(
    //   t =>
    //     isIdEqual(t.serviceId, SERVICE_IDS.DESTINATION_BUYER_SERVICE_ID) &&
    //     t.containsDestinationTrip === true &&
    //     t.containsDestination === false
    // );

    const destBuyer = emailTemplates.filter(
      t =>
        isIdEqual(t.serviceId, SERVICE_IDS.DESTINATION_BUYER_SERVICE_ID) &&
        t.containsDestination === true &&
        t.containsDestinationTrip === false &&
        t.containsBroker === false
    );

    const moreBuyer = emailTemplates.filter(
      t =>
        isIdEqual(t.serviceId, SERVICE_IDS.DESTINATION_BUYER_SERVICE_ID) &&
        t.containsDestination === false &&
        t.containsDestinationTrip === false &&
        t.containsBroker === false
    );

    const offerHist = emailTemplates.filter(
      t =>
        isIdEqual(t.serviceId, SERVICE_IDS.DESTINATION_BUYER_SERVICE_ID) &&
        t.containsDestination === true &&
        t.containsDestinationTrip === false &&
        t.containsBroker === true
    );

    const finalList = [...destBuyer, ...moreBuyer];

    const trips = destinationInfo?.buyerTrips || [];
    const offerHistory = destinationInfo?.destinationOfferHistoryInfo || [];

    if (destTrips.length > 0) {
      for (let i = 0; i < destTrips.length; i++) {
        for (let j = 0; j < trips.length; j++) {
          let tripName = trips[j].tripName ? trips[j].tripName : '';
          const newTemp = { ...destTrips[i], selectedSegmentServiceId: trips[j].tripId, displayName: tripName };
          finalList.push(newTemp);
        }
      }
    }

    if (offerHist.length > 0) {
      for (let i = 0; i < offerHist.length; i++) {
        for (let j = 0; j < offerHistory.length; j++) {
          if (!offerHistory[j].offerHistory) continue;
          let agent = Array.isArray(brokerAgents) ? brokerAgents.find(o => o.agentId === offerHistory[j].offerHistory.agentId) : null;
          let displayName = agent ? `${agent.firstName} ${agent.lastName}` : '';
          const newTemp = {
            ...offerHist[i],
            selectedSegmentServiceId: offerHistory[j].offerHistory.offerHistoryId,
            displayName: displayName
          };
          finalList.push(newTemp);
        }
      }
    }

    return finalList;
  };

  const validTemplates = createDestBuyerTemplates();

  const countryOptionsAll =
    props.enumerations && Array.isArray(enumerations.countries) ? props.enumerations.countries.filter(s => s.isActive) : [];
  const provinceOptionsAll =
    props.enumerations && Array.isArray(enumerations.provinces) ? props.enumerations.provinces.filter(s => s.isActive) : [];

  const offerHistoryDto = Array.isArray(destinationInfo?.destinationOfferHistoryInfo) ? destinationInfo.destinationOfferHistoryInfo : [];

  const authCommentServiceTypes =
    enumerations && enumerations.authCommentService && enumerations.authCommentService.length > 0
      ? enumerations.authCommentService.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentRegardingTypes =
    enumerations && enumerations.authCommentRegarding && enumerations.authCommentRegarding.length > 0
      ? enumerations.authCommentRegarding.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const mortgageLeadsTypes =
    enumerations && Array.isArray(enumerations.mortgageLeads)
      ? enumerations.mortgageLeads.filter(s => s.isActive === true && s.id !== ZERO_GUID)
      : [];

  const livingStatusTypes =
    enumerations && enumerations.livingStatusTypes && enumerations.livingStatusTypes.length > 0
      ? enumerations.livingStatusTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const typeOfRelocationTypes =
    enumerations && enumerations.typeOfRelocations && enumerations.typeOfRelocations.length > 0
      ? enumerations.typeOfRelocations.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const closingCostMethodTypes =
    enumerations && enumerations.closingCostMethodTypes && enumerations.closingCostMethodTypes.length > 0
      ? enumerations.closingCostMethodTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const selectedMortgageLeadIds =
    selectedMortgageLeads.map(lead => ({
      id: lead.selectedMortgageLeadId,
      title: mortgageLeadsTypes.find(type => isIdEqual(type.id, lead.selectedMortgageLeadId))?.title || ''
    })) || [];

  const defaultSelectedMortgageLeadIds = isNewMortgageLeadRecord
    ? mortgageLeadsTypes.filter(x => x.id !== ZERO_GUID).map(x => ({ id: x.id, title: x.title }))
    : selectedMortgageLeads.map(lead => ({
      id: lead.selectedMortgageLeadId,
      title: mortgageLeadsTypes.find(type => isIdEqual(type.id, lead.selectedMortgageLeadId))?.title || ''
    }));

  const mortgageLenderSelectedOptions = mortgageLeadsTypes.filter(x => x.id !== ZERO_GUID);

  const createOfferRows = offerHistoryDto => {
    if (!offerHistoryDto || !Array.isArray(offerHistoryDto)) return [];
    return offerHistoryDto.map(dto => {
      const addr = dto?.address ?? {};
      const oh = dto?.offerHistory ?? {};

      let revenue = destinationInfo?.offerHistoryRevenue || {};
      let actualReferralAmount = oh?.status === 'Closed' ? revenue?.actualReferralAmount ?? null : null;
      let isReferralCollected = oh?.status === 'Closed' && actualReferralAmount !== null && actualReferralAmount > 0 ? true : false;

      return {
        original: dto,
        offerHistoryId: oh?.offerHistoryId ?? null,
        authorizationFileId: oh?.authorizationFileId ?? Number(id),
        status: oh?.status ?? '',
        purchasePrice: oh?.purchasePrice ?? null,
        scheduleCloseDate: oh?.scheduleCloseDate ?? null,
        actualCloseDate: oh?.actualCloseDate ?? null,
        hasClosedWithProvider: !!oh?.hasClosedWithProvider,
        hasReferralDue: !!oh?.hasReferralDue,
        referralPercentage: oh?.referralPercentage ?? null,
        agentCommissionPercentage: oh?.agentCommissionPercentage ?? null,
        agentId: oh?.agentId ?? null,
        editedAddress: addr ?? null,
        contractDate: oh?.contractDate ?? null,
        offerAmount: oh?.offerAmount ?? null,
        expectedReferralAmount: dto?.expectedReferralAmount ?? null,
        reasonNotCollected: oh?.reasonNotCollected ?? null,
        fallThroughDate: oh?.fallThroughDate ?? null,
        fallThroughReason: oh?.fallThroughReason ?? '',
        isReferralCollected: isReferralCollected,
        referralCollectedAmount: actualReferralAmount,
        isSelectedDestinationAddress: !!oh?.isSelectedDestinationAddress
      };
    });
  };

  let offerRows = createOfferRows(offerHistoryDto);

  const hasSentAnyMortgageLeadLetter = (selectedMortgageLeads ?? []).some(l => l.hasSentLetter);

  const [showTriggeredComment, setShowTriggeredComment] = useState(false);
  const [showComment, setShowComment] = useState(false);

  const [currentStatus, setCurrentStatus] = useState(
    buyer?.buyerStatusId ? props.enumerations.buyerStatuses.find(bs => bs.id === buyer.buyerStatusId)?.title : 'Initiated'
  );

  useEffect(() => {
    if (props.enumerations?.buyerStatuses && buyer?.buyerStatusId) {
      setCurrentStatus(props.enumerations.buyerStatuses.find(bs => bs.id === buyer.buyerStatusId)?.title ?? 'Initiated');
    }
  }, [buyer?.buyerStatusId]);

  const isFailure = r => r?.type?.endsWith('_FAILURE');

  // let destAddress =
  //   addresses && Array.isArray(addresses) ? addresses.find(a => a.addressTypeId === 'c467fd82-e2d4-4d26-8827-5df0a0b5c6a5') : null;

  let buyerStatus = 'Initiated';
  if (props.enumerations.buyerStatuses.find(bs => bs.id === buyer.buyerStatusId)) {
    const buyerStatusTitle = props.enumerations.buyerStatuses.find(bs => bs.id === buyer.buyerStatusId).title;
    if (buyerStatusTitle.length > 0) {
      buyerStatus = buyerStatusTitle;
    }
  }

  // const [currentStatusTypes, setCurrentStatusTypes] = useState(setStatusTypes(type, buyerStatus));
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingOfferHistory, setIsLoadingOfferHistory] = useState(false);
  const [currentTripId, setCurrentTripId] = useState(buyerTrips[0]?.tripId ?? null);
  const trip = buyerTrips.find(t => t.tripId === currentTripId) ?? null;

  useEffect(() => {
    setCurrentTripId(buyerTrips[0]?.tripId ?? null);
  }, [type]);

  const createTrip = async values => {
    setIsLoading(true);
    let newValues = {};

    newValues.tripName = values.tripName ? values.tripName : '';
    newValues.tripCategoryId = values.tripCategoryId ? values.tripCategoryId : HOME_FINDING_TRIP_CATEGORY_ID;
    newValues.familyAttending = values.familyAttending ? values.familyAttending.join(',') : values.familyAttending;
    newValues.typeOfTrip = values.typeOfTrip ? values.typeOfTrip : '';
    // The API requires both trip dates, so a blank one falls back to the other rather than to today, which could put
    // the end before the start.
    newValues.tripStartDate = values.tripStartDate || values.tripEndDate || new Date();
    newValues.tripEndDate = values.tripEndDate || newValues.tripStartDate;
    newValues.departureDate = values.departureDate ? values.departureDate : new Date();
    newValues.arrivalDate = values.arrivalDate ? values.arrivalDate : new Date();
    newValues.tripDuration = values.tripDuration ? values.tripDuration : 0;
    newValues.departureAddressId = values.departureAddressId ? values.departureAddressId : 0;
    newValues.destinationAddressId = values.destinationAddressId ? values.destinationAddressId : 0;
    newValues.specialNeeds = values.specialNeeds ? values.specialNeeds : '';
    newValues.notes = values.notes ? values.notes : '';

    if (values.hasBookingDetails && values.hasBookingDetails === 'Self Booked') {
      newValues.hasBookingDetails = false;
    } else {
      newValues.hasBookingDetails = true;
    }

    newValues.airTransport = values.airTransport;
    newValues.airTransportDepartureDate = values.airTransportDepartureDate;
    newValues.airTransportArrivalDate = values.airTransportArrivalDate;
    newValues.airTransportReturnDepartureDate = values.airTransportReturnDepartureDate;
    newValues.airTransportReturnArrivalDate = values.airTransportReturnArrivalDate;

    newValues.hotelBooking = values.hotelBooking;
    newValues.hotelName = values.hotelName;
    newValues.hotelAddressId = values.hotelAddressId;
    newValues.hotelCheckInDate = values.hotelCheckInDate;
    newValues.hotelCheckOutDate = values.hotelCheckOutDate;
    newValues.hotelDurationOfStay = values.hotelDurationOfStay;

    newValues.rentalCarBooking = values.rentalCarBooking;
    newValues.rentalCarClassId = values.rentalCarClassId;
    newValues.otherRentalCar = values.otherRentalCar;
    newValues.rentalCarStartDate = values.rentalCarStartDate;
    newValues.rentalCarEndDate = values.rentalCarEndDate;
    newValues.rentalCarDuration = values.rentalCarDuration;
    newValues.addedBy = values.addedBy ? values.addedBy : 0;
    newValues.addedOn = values.addedOn ? values.addedOn : new Date();
    newValues.modifiedBy = 0;
    newValues.modifiedOn = new Date();

    if (values.hasBookingDetails && values.hasBookingDetails === 'Self Booked') {
      newValues.hasBookingDetails = false;
    } else {
      newValues.hasBookingDetails = true;
    }
    const resp = await props.updateAuthDestinationTripsBuyer(buyerId, newValues);

    if (isFailure(resp)) {
      props.showToast('Failed to create the house hunting trip. Please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return;
    }

    const destInfo = await props.getAuthDestinationServices(id);
    if (isFailure(destInfo)) {
      props.showToast('Trip created, but failed to refresh trips.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return;
    }

    const ds = destInfo?.response?.destinationServices;
    const newId = resp?.response?.tripId ?? (ds?.buyerTrips || []).slice(-1)[0]?.tripId;
    if (newId) setCurrentTripId(newId);

    props.showToast('New House Hunting Trip created successfully.', { userMustDismiss: false, severity: 'success' });
    setIsLoading(false);
  };

  const deleteTrip = async () => {
    if (!currentTripId) return;

    const resp = await props.deleteAuthDestinationTripsBuyer(currentTripId);

    if (isFailure(resp)) {
      props.showToast('Failed to delete the trip, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    }

    props.showToast('Trip deleted successfully.', { userMustDismiss: false, severity: 'success' });

    const destInfo = await props.getAuthDestinationServices(id);
    if (isFailure(destInfo)) return;

    const ds = destInfo?.response?.destinationServices;
    setCurrentTripId(ds?.buyerTrips?.[0]?.tripId ?? null);
  };

  const brokerAgentSearchInfo = {
    searchingColumns: [
      { name: 'vendorId', title: 'Id' },
      { name: 'companyName', title: 'Company Name' }
    ],
    searchingColumnExtensions: [
      { columnName: 'vendorId', width: 150 },
      { columnName: 'companyName', width: 250 }
    ],
    searchingRows: vendors,
    nameKey: 'companyName',
    idKey: 'vendorId'
  };

  // const brokerAgentSearchInfo = {
  //   searchingColumns: [
  //     { name: 'agentId', title: 'Id' },
  //     { name: 'agentTypeIdReadable', title: 'Type of Agent' },
  //     { name: 'firstName', title: 'First Name' },
  //     { name: 'lastName', title: 'Last Name' },
  //     { name: 'companyName', title: 'Company Name' },
  //     { name: 'citiesServed', title: 'City' }
  //   ],
  //   searchingColumnExtensions: [
  //     { name: 'agentId', width: 100 },
  //     { columnName: 'agentTypeIdReadable', width: 150 },
  //     { columnName: 'firstName', width: 200 },
  //     { columnName: 'lastName', width: 200 },
  //     { columnName: 'companyName', width: 300 },
  //     { columnName: 'citiesServed', width: 150 }
  //   ],
  //   searchingRows: brokerAgents && brokerAgents.length > 0 ? brokerAgents.map(agent => ({
  //     ...agent,
  //     agentTypeIdReadable: props.enumerations.agentTypes.find(type => type.id === agent.agentTypeId)?.title ?? ''
  //   })) : [],
  //   nameKey: 'firstName',
  //   idKey: 'agentId'
  // };

  const vendorOptions = React.useMemo(() => {
    const destServices = details?.destinationServices;

    const renterVendorId = destServices?.destinationRenterInfo?.vendorId;

    const vendorIdSet = new Set([renterVendorId]);
    const options = Array.from(vendorIdSet)
      .map(vendorId => {
        const v = (vendorsPreferredVendorSorted || []).find(x => x.vendorId === vendorId);
        if (!v?.officeEmail || !v?.companyName) return null;

        return {
          vendorId: vendorId,
          officeEmail: v.officeEmail,
          companyName: v.companyName
        };
      })
      .filter(Boolean);

    return options;
  }, [details, vendorsPreferredVendorSorted]);

  const mainCardTabs = [{ header: 'Buyer Agent', order: 1, iconPath: ['fas', 'fa-truck-moving'] }];
  const mortgageLeadsTabs = [{ header: 'Mortgage Leads', order: 1, iconPath: ['fas', 'fa-truck-moving'] }];
  const revenueTabs = [{ header: 'Revenue', order: 1, iconPath: ['fas', 'fa-truck-moving'] }];

  let selectedBuyerBrokerId = buyer?.buyerAgentId ?? 0;

  let selectedBuyerBroker = null;

  if (brokerAgents) {
    selectedBuyerBroker = brokerAgents.find(s => s.agentId === selectedBuyerBrokerId);
  } // location, unit size, adr? - they'll give us a starting point, something to start with. They'll start with an excel sheet to start with. Once a month, once a quarter? Tuesday of next week they'll give us the initial batch of data

  const offerHistoryColumns = [
    {
      accessorKey: 'status',
      header: 'Status',
      type: 'dropdown',
      options: ['Under Contract', 'Fall Through', 'Closed'],
      size: 60,
      defaultVal: 'Under Contract',
      required: true
    },
    {
      accessorKey: 'offerAmount',
      header: 'Offer Amount',
      type: 'number',
      size: 60,
      Cell: ({ cell }) => (cell.getValue() ? formatMoney(cell.getValue()) : '-')
    },
    {
      accessorKey: 'isSelectedDestinationAddress',
      header: 'Selected Destination Address',
      type: 'checkbox',
      size: 60,
      Cell: ({ cell }) => (cell.getValue() && cell.getValue() === true ? 'Yes' : '-')
    },
    {
      accessorKey: 'scheduleCloseDate',
      header: 'Schedule Close',
      type: 'date',
      size: 60,
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '-')
    },
    {
      accessorKey: 'actualCloseDate',
      header: 'Actual Close',
      type: 'date',
      size: 60,
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '-')
    },
    { accessorKey: 'hasReferralDue', header: 'Referral Due', type: 'checkbox', size: 60, defaultVal: false, hideInTable: true },
    {
      accessorKey: 'referralPercentage',
      header: 'Referral %',
      type: 'text',
      size: 50,
      Cell: ({ cell }) => (cell.getValue() ? `${cell.getValue()}%` : '-')
    },
    {
      accessorKey: 'agentCommissionPercentage',
      header: 'Agent Commission %',
      type: 'text',
      size: 70,
      Cell: ({ cell }) => (cell.getValue() ? `${cell.getValue()}%` : '-')
    },
    {
      accessorKey: 'expectedReferralAmount',
      header: 'Expected Referral Amount',
      type: 'money',
      disabled: true,
      computeValue: values => calculateExpectedReferralAmount(values) ?? '',
      size: 60,
      Cell: ({ cell }) => (cell.getValue() ? formatMoney(cell.getValue()) : '-')
    },
    {
      accessorKey: 'isReferralCollected',
      header: 'Referral Collected',
      type: 'checkbox',
      disabled: true,
      size: 60,
      hideInTable: true
    },
    {
      accessorKey: 'referralCollectedAmount',
      header: 'Referral Collected Amount',
      type: 'number',
      disabled: true,
      size: 60,
      hideInTable: true
    },
    {
      accessorKey: 'reasonNotCollected',
      header: 'Reason Not Collected',
      type: 'text',
      disabled: false,
      size: 60,
      hideInTable: true
    },
    {
      accessorKey: 'fallThroughDate',
      header: 'Fall Through Date',
      type: 'date',
      size: 60,
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '-'),
      hideInTable: true
    },
    {
      accessorKey: 'fallThroughReason',
      header: 'Fall Through Reason',
      type: 'text',
      size: 50,
      hideInTable: true
    },
    {
      header: 'Contract Date',
      accessorKey: 'contractDate',
      type: 'date',
      size: 60,
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '-')
    },
    {
      header: 'Address',
      accessorKey: 'editedAddress',
      type: 'googleAddressSearch',
      required: false,
      Cell: ({ cell }) => (cell.getValue() ? cell.getValue().addressLine1 : '-'),
      displayValue: 'addressLine1',
      tab: 1,
      countries: countryOptionsAll,
      provinces: provinceOptionsAll
    }
  ];

  const mainCardBuyerSummaries = [
    {
      header: 'Broker',
      accessorKey: 'buyerAgentId',
      nameKey: 'firstName',
      nameValue: selectedBuyerBroker ? selectedBuyerBroker.companyName : '',
      type: 'advanced-search',
      searchInfo: brokerAgentSearchInfo,
      value: buyer?.buyerAgentId || 0,
      tab: 1
    },
    //{ header: 'Broker Email', type: 'text', value: selectedBuyerBroker?.email ?? '', tab: 1, hideInModal: true },
    //{ header: 'Broker Phone', type: 'text', value: selectedBuyerBroker?.phone ?? '', tab: 1, hideInModal: true },
    // { header: 'New Address', type: 'text', value: createAddressName(destAddress), tab: 1, hideInModal: true },
    { header: 'Agent Name', accessorKey: 'buyerAgentName', type: 'text', value: buyer?.buyerAgentName ?? '', tab: 1 },
    { header: 'Agent Email', accessorKey: 'buyerAgentEmail', type: 'text', value: buyer?.buyerAgentEmail ?? '', tab: 1 },
    { header: 'Agent Phone', accessorKey: 'buyerAgentPhone', type: 'text', value: buyer?.buyerAgentPhone ?? '', tab: 1 }
  ];

  const mortgageLeadsSummaries = [
    {
      header: 'Mortgage Letters Sent',
      accessorKey: 'sentOnDate',
      type: 'date',
      value: hasSentAnyMortgageLeadLetter ? selectedMortgageLeads[0]?.sentOnDate || null : null,
      tab: 1,
      hideInModal: true
    },
    {
      header: 'Mortgage Lender Selected',
      accessorKey: 'mortgageLenderSelected',
      type: 'dropdown-v2',
      options: mortgageLenderSelectedOptions,
      value: mortgageLeadInfo?.mortgageLenderSelected || ZERO_GUID,
      tab: 1
      //hideInModal: !hasSentAnyMortgageLeadLetter
    },
    { dividerLine: true, tab: 1 },
    {
      header: 'Mortgage Leads',
      accessorKey: 'selectedMorgageLeads',
      type: 'multi-select-v2-enum',
      options: mortgageLeadsTypes,
      value: defaultSelectedMortgageLeadIds,
      tab: 1,
      disabled: hasSentAnyMortgageLeadLetter
      //hideInModal: hasSentAnyMortgageLeadLetter
    },
    {
      header: 'Reason for Deselection',
      accessorKey: 'reasonForDeselection',
      type: 'text',
      searchInfo: brokerAgentSearchInfo,
      value: mortgageLeadInfo?.reasonForDeselection || '',
      disabled: hasSentAnyMortgageLeadLetter,
      tab: 1,
      //hideInModal: hasSentAnyMortgageLeadLetter,
      showWhen: () => {
        const total = mortgageLeadsTypes.length;
        const selected = selectedMortgageLeadIds.length;
        return total > 0 && selected < total;
      },

      showWhenModal: ({ values }) => {
        const total = mortgageLeadsTypes.length;
        const selected = (values.selectedMorgageLeads ?? []).length;
        return total > 0 && selected < total;
      }
    },
    {
      header: 'Closing Cost Method',
      type: 'dropdown-v2',
      accessorKey: 'closingCostMethod',
      value: mortgageLeadInfo.closingCostMethod,
      options: closingCostMethodTypes,
      //hideInModal: hasSentAnyMortgageLeadLetter,
      disabled: hasSentAnyMortgageLeadLetter,
      tab: 1,
      required: true
    },
    {
      header: 'Type of Relocation',
      type: 'dropdown-v2',
      accessorKey: 'typeOfRelocation',
      disabled: hasSentAnyMortgageLeadLetter,
      value: mortgageLeadInfo.typeOfRelocation,
      options: typeOfRelocationTypes,
      tab: 1,
      required: true
      //hideInModal: hasSentAnyMortgageLeadLetter
    },
    {
      header: 'Status',
      type: 'dropdown-v2',
      accessorKey: 'housingStatus',
      value: mortgageLeadInfo.housingStatus,
      disabled: hasSentAnyMortgageLeadLetter,
      options: livingStatusTypes,
      required: true,
      //hideInModal: hasSentAnyMortgageLeadLetter,
      tab: 1
    },
    {
      header: 'Co-Applicant Email',
      disabled: hasSentAnyMortgageLeadLetter,
      type: 'text',
      accessorKey: 'coApplicantEmail',
      value: mortgageLeadInfo.coApplicantEmail || '',
      //hideInModal: hasSentAnyMortgageLeadLetter,
      tab: 1
    },
    {
      header: 'Co-Applicant Phone',
      disabled: hasSentAnyMortgageLeadLetter,
      type: 'text',
      accessorKey: 'coApplicantPhone',
      value: mortgageLeadInfo.coApplicantPhone || '',
      //hideInModal: hasSentAnyMortgageLeadLetter,
      tab: 1
    },
    {
      header: 'Is Direct Bill Eligible',
      type: 'checkbox',
      accessorKey: 'isDirectBillEligible',
      disabled: hasSentAnyMortgageLeadLetter,
      value: mortgageLeadInfo.isDirectBillEligible || false,
      //hideInModal: hasSentAnyMortgageLeadLetter,
      tab: 1
    },
    {
      header: 'Is Spanish Speaking',
      type: 'checkbox',
      accessorKey: 'isSpanishSpeaking',
      disabled: hasSentAnyMortgageLeadLetter,
      value: mortgageLeadInfo.isSpanishSpeaking || false,
      //hideInModal: hasSentAnyMortgageLeadLetter,
      tab: 1
    },
    {
      header: 'Has Benefits Cap Amount',
      type: 'checkbox',
      accessorKey: 'hasBenefitsCapAmount',
      disabled: hasSentAnyMortgageLeadLetter,
      value: mortgageLeadInfo.hasBenefitsCapAmount || false,
      //hideInModal: hasSentAnyMortgageLeadLetter,
      tab: 1
    },
    {
      header: 'Cap Amount',
      disabled: hasSentAnyMortgageLeadLetter,
      type: 'money',
      accessorKey: 'capAmount',
      value: mortgageLeadInfo.capAmount || null,
      tab: 1,
      //hideInModal: hasSentAnyMortgageLeadLetter,
      dependentOn: 'hasBenefitsCapAmount'
    },
    {
      header: 'Comments',
      disabled: hasSentAnyMortgageLeadLetter,
      type: 'notes',
      accessorKey: 'comments',
      value: mortgageLeadInfo.comments || '',
      //hideInModal: hasSentAnyMortgageLeadLetter,
      tab: 1
    }
  ];

  const revenueSummaries = [
    {
      header: 'Expected Revenue',
      type: 'money',
      value: destinationInfo?.offerHistoryRevenue?.expectedReferralAmount,
      tab: 1,
      disabled: true
    },
    {
      header: 'Actual Referral Amount',
      type: 'money',
      value: destinationInfo?.offerHistoryRevenue?.actualReferralAmount,
      tab: 1,
      disabled: true
    }
  ];

  const onCancelService = async () => {
    setCurrentStatus('Canceled');
    let newVals = { ...destinationInfo?.destinationBuyerInfo };

    // Same fields regardless of renter or buyer
    newVals.serviceInitiationDate = newVals.serviceInitiationDate ?? fileServices.addedOn;
    newVals.serviceCanceledDate = new Date().toISOString();
    newVals.serviceCompletionDate = null;
    newVals.serviceOnHoldDate = null;
    newVals.authorizationId = props.id;
    newVals.buyerStatusId = props.enumerations.buyerStatuses.find(s => s.title === 'Canceled')?.id ?? null;

    const resp = await props.updateAuthDestinationServicesBuyer(id, newVals);
    if (resp.type === UPDATE_AUTH_DESTINATION_SERVICES_BUYER_FAILURE) {
      props.showToast('Failed to update the employee destination services info, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      setIsLoading(false);
      return false;
    } else {
      // setCurrentStatusTypes(setStatusTypes(type, currentStatus));
      const getStatusDatesResp = await props.getServiceStatusDates(id);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      } else {
        setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Buyer'));
        setIsLoading(false);
        return true;
      }
    }
  };

  // The API recalculates the status once the canceled date is cleared, so it isn't set here.
  const onReactivateService = async () => {
    let newVals = { ...destinationInfo?.destinationBuyerInfo };

    newVals.serviceInitiationDate = newVals.serviceInitiationDate ?? fileServices.addedOn;
    newVals.serviceCanceledDate = null;

    const resp = await props.updateAuthDestinationServicesBuyer(id, newVals);
    if (resp.type === UPDATE_AUTH_DESTINATION_SERVICES_BUYER_FAILURE) {
      props.showToast('Failed to update the employee destination services info, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      setIsLoading(false);
      return false;
    } else {
      const getStatusDatesResp = await props.getServiceStatusDates(id);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      } else {
        setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Buyer'));
        setIsLoading(false);
        return true;
      }
    }
  };

  const onCompleteService = async () => {
    setCurrentStatus('Completed');
    let newVals = { ...destinationInfo?.destinationBuyerInfo };

    // Same fields regardless of renter or buyer
    newVals.serviceInitiationDate = newVals.serviceInitiationDate ?? fileServices.addedOn;
    newVals.serviceCompletionDate = newVals.serviceCompletionDate == null ? new Date().toISOString() : null;
    newVals.serviceCanceledDate = null;
    newVals.serviceOnHoldDate = null;
    newVals.buyerStatusId = props.enumerations.buyerStatuses.find(s => s.title === 'Completed')?.id ?? null;

    const resp = await props.updateAuthDestinationServicesBuyer(id, newVals);
    if (resp.type === UPDATE_AUTH_DESTINATION_SERVICES_BUYER_FAILURE) {
      props.showToast('Failed to update the employee destination services info, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      setIsLoading(false);
      return false;
    } else {
      // setCurrentStatusTypes(setStatusTypes(type, currentStatus));
      const getStatusDatesResp = await props.getServiceStatusDates(id);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      } else {
        setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Buyer'));
        setIsLoading(false);
        return true;
      }
    }
  };

  const onSetOnHold = async () => {
    setCurrentStatus('On Hold');
    let newVals = { ...destinationInfo?.destinationBuyerInfo };

    // Same fields regardless of renter or buyer
    newVals.serviceInitiationDate = newVals.serviceInitiationDate ?? fileServices.addedOn;
    newVals.serviceOnHoldDate = new Date().toISOString();
    newVals.serviceCompletionDate = null;
    newVals.serviceCanceledDate = null;
    newVals.buyerStatusId = props.enumerations.buyerStatuses.find(s => s.title === 'On Hold')?.id ?? null;

    const resp = await props.updateAuthDestinationServicesBuyer(id, newVals);
    if (resp.type === UPDATE_AUTH_DESTINATION_SERVICES_BUYER_FAILURE) {
      props.showToast('Failed to update the employee destination services info, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      setIsLoading(false);
      return false;
    } else {
      // setCurrentStatusTypes(setStatusTypes(type, currentStatus));
      const getStatusDatesResp = await props.getServiceStatusDates(id);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      } else {
        setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Buyer'));
        setIsLoading(false);
        return true;
      }
    }
  };

  const takeOffHold = async () => {
    setCurrentStatus('Active');
    let newVals = { ...destinationInfo?.destinationBuyerInfo };

    // Same fields regardless of renter or buyer
    // Same fields regardless of renter or buyer
    newVals.serviceInitiationDate = newVals.serviceInitiationDate ?? fileServices.addedOn;
    newVals.serviceOnHoldDate = null;
    newVals.serviceCompletionDate = null;
    newVals.serviceCanceledDate = null;
    newVals.buyerStatusId = props.enumerations.buyerStatuses.find(s => s.title === 'Initiated')?.id ?? null;

    const resp = await props.updateAuthDestinationServicesBuyer(id, newVals);
    if (resp.type === UPDATE_AUTH_DESTINATION_SERVICES_BUYER_FAILURE) {
      props.showToast('Failed to update the employee destination services info, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      setIsLoading(false);
      return false;
    } else {
      // setCurrentStatusTypes(setStatusTypes(type, currentStatus));
      const getStatusDatesResp = await props.getServiceStatusDates(id);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      } else {
        setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Buyer'));
        setIsLoading(false);
        return true;
      }
    }
  };


  const updateBuyerFields = async (tab, values) => {
    setIsLoading(true);

    const payload = {
      ...buyer,
      authorizationFileId: id,
      serviceInitiationDate: buyer.serviceInitiationDate ?? fileServices.addedOn,
      serviceStatus: currentStatus,
      buyerStatusId: props.enumerations.buyerStatuses.find(s => s.title === currentStatus)?.id ?? null,
      buyerAgentId: values.buyerAgentId ?? buyer.buyerAgentId ?? null,
      buyerAgentName: values.buyerAgentName ?? '',
      buyerAgentEmail: values.buyerAgentEmail ?? '',
      buyerAgentPhone: values.buyerAgentPhone ?? '',
      serviceCanceledDate: values.serviceCanceledDate ?? buyer.serviceCanceledDate ?? null,
      mortgageLenderSelected: values.mortgageLenderSelected ?? buyer.mortgageLenderSelected ?? '',
      // contractDate: values.contractDate ?? buyer.contractDate ?? null,
      addedBy: 0,
      modifiedBy: 0
    };

    const resp = await props.updateAuthDestinationServicesBuyer(id, payload);
    if (resp.type === UPDATE_AUTH_DESTINATION_SERVICES_BUYER_FAILURE) {
      props.showToast('Failed to update the destination services info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      // const getResp = await props.getAuthDestinationServices(id);
      // console.log(getResp);
      // if (getResp.type === GET_AUTH_DESTINATION_SERVICES_FAILURE) {
      //   return false;
      // } else {
      //   const getStatusDatesResp = await props.getServiceStatusDates(id);
      //   if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
      //     return false;
      //   } else {
      //     setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Buyer'));
      //     setIsLoading(false);
      //     return true;
      //   }
      // }
      return true;
    }
  };

  const handleUpdateMortgageLeads = async (tab, values) => {
    setIsLoading(true);

    const selectedIds = (values.selectedMorgageLeads ?? []).map(x => (typeof x === 'string' ? x : x.id));

    const payload = {
      mortgageLead: {
        ...mortgageLeadInfo,
        reasonForDeselection: values.reasonForDeselection ?? '',
        closingCostMethod: values.closingCostMethod ?? ZERO_GUID,
        typeOfRelocation: values.typeOfRelocation ?? ZERO_GUID,
        housingStatus: values.housingStatus ?? ZERO_GUID,
        coApplicantEmail: values.coApplicantEmail ?? '',
        coApplicantPhone: values.coApplicantPhone ?? '',
        isDirectBillEligible: values.isDirectBillEligible ?? false,
        isSpanishSpeaking: values.isSpanishSpeaking ?? false,
        hasBenefitsCapAmount: values.hasBenefitsCapAmount ?? false,
        capAmount: values.capAmount ?? null,
        comments: values.comments ?? '',
        addedBy: mortgageLeadInfo.addedBy ?? 0,
        mortgageLenderSelected: values.mortgageLenderSelected ?? ZERO_GUID
      },
      selectedMortgageLeads: selectedIds.map(guid => ({
        mortgageLeadId: mortgageLeadInfo?.mortgageLeadId ?? null,
        selectedMortgageLeadId: guid,
        hasSentLetter: false,
        addedBy: mortgageLeadInfo?.addedBy ?? 0,
        modifiedBy: 0,
        sentOnDate: null
      }))
    };
    const resp = updateMortgageLeads(id, payload);
    setIsLoading(false);
    return resp;
  };

  const createOfferHistoryRow = async values => {
    setIsLoadingOfferHistory(true);

    const dto = {
      offerHistory: {
        offerHistoryId: 0,
        authorizationFileId: props.id,
        status: values?.status ? values.status : '',
        purchasePrice: values?.purchasePrice ? values.purchasePrice : null,
        scheduleCloseDate: values?.scheduleCloseDate && values?.scheduleCloseDate.length > 0 ? values.scheduleCloseDate : null,
        actualCloseDate: values?.actualCloseDate && values?.actualCloseDate.length > 0 ? values.actualCloseDate : null,
        hasClosedWithProvider: values?.hasClosedWithProvider,
        hasReferralDue: values?.hasReferralDue,
        referralPercentage: values?.referralPercentage ?? '',
        agentCommissionPercentage: values?.agentCommissionPercentage ?? '',
        agentId: values?.agentId == null ? null : values?.agentId,
        fallThroughDate: values?.fallThroughDate && values?.fallThroughDate.length > 0 ? values.fallThroughDate : null,
        fallThroughReason: values?.fallThroughReason ?? '',
        contractDate: values?.contractDate && values?.contractDate.length > 0 ? values.contractDate : null,
        addedBy: 0,
        addedOn: new Date(),
        modifiedBy: 0,
        modifiedOn: new Date(),
        offerAmount: toNumber(values?.offerAmount),
        reasonNotCollected: values?.reasonNotCollected ?? '',
        isSelectedDestinationAddress: values?.isSelectedDestinationAddress ?? false
      },
      address: {
        ...values.editedAddress,
        addressId: 0,
        addressTypeId: '00762a48-7fa2-4deb-8284-864c42fb3543',
        addedBy: 0,
        addedOn: new Date().toISOString(),
        modifiedBy: 0,
        modifiedOn: new Date().toISOString()
      }
    };

    const resp = await props.postOfferHistoryList(id, dto);
    if (isFailure(resp)) {
      setIsLoadingOfferHistory(false);
      return false;
    }
    const getResp = await props.getOfferHistoryList(id);
    await props.getAuthorizationSummaryAddress(id); // Needed to refresh
    await props.getAuthDestinationServices(id); // Needed to refresh possible destination services status
    offerRows = createOfferRows(getResp.response || []);
    setIsLoadingOfferHistory(false);
    return !isFailure(getResp);
  };

  const updateOfferHistoryRow = async (row, values) => {
    setIsLoadingOfferHistory(true);

    const offerHistoryId = row?.original?.offerHistory?.offerHistoryId ?? row?.original?.offerHistoryId ?? row?.offerHistoryId;
    const currentAddrId = row?.original?.editedAddress?.addressId ?? row?.addressId ?? values?.addressId ?? 0;
    const dto = {
      offerHistory: {
        offerHistoryId: offerHistoryId,
        authorizationFileId: props.id,
        status: values?.status ? values.status : '',
        purchasePrice: values?.purchasePrice ? values.purchasePrice : null,
        scheduleCloseDate: values?.scheduleCloseDate && values?.scheduleCloseDate.length > 0 ? values.scheduleCloseDate : null,
        actualCloseDate: values?.actualCloseDate && values?.actualCloseDate.length > 0 ? values.actualCloseDate : null,
        hasClosedWithProvider: values?.hasClosedWithProvider,
        hasReferralDue: values?.hasReferralDue,
        referralPercentage: values?.referralPercentage ?? '',
        agentCommissionPercentage: values?.agentCommissionPercentage ?? '',
        // agentId: values?.agentId == null ? null : values?.agentId,
        fallThroughDate: values?.fallThroughDate && values?.fallThroughDate.length > 0 ? values.fallThroughDate : null,
        fallThroughReason: values?.fallThroughReason ?? '',
        contractDate: values?.contractDate ?? null,
        addedBy: 0,
        addedOn: new Date(),
        modifiedBy: 0,
        modifiedOn: new Date(),
        offerAmount: values?.offerAmount ?? null,
        reasonNotCollected: values?.reasonNotCollected ?? '',
        isSelectedDestinationAddress: values?.isSelectedDestinationAddress ?? false
      },
      address: {
        ...values.editedAddress,
        addressId: currentAddrId,
        addressTypeId: 'c467fd82-e2d4-4d26-8827-5df0a0b5c6a5',
        addedBy: 0,
        addedOn: new Date().toISOString(),
        modifiedBy: 0,
        modifiedOn: new Date().toISOString()
      }
    };

    const resp = await props.updateOfferHistoryList(id, offerHistoryId, dto);
    if (isFailure(resp)) {
      setIsLoadingOfferHistory(false);
      return false;
    }
    const getResp = await props.getOfferHistoryList(id);
    await props.getAuthorizationSummaryAddress(id); // Needed to refresh
    await props.getAuthDestinationServices(id); // Needed to refresh possible destination services status
    offerRows = createOfferRows(getResp.response || []);
    setIsLoadingOfferHistory(false);
    return !isFailure(getResp);
  };

  const deleteOfferHistoryRow = async offer => {
    setIsLoadingOfferHistory(true);
    const offerId = offer?.original?.offerHistoryId;
    const resp = await props.deleteOfferHistoryList(props.id, offerId);
    if (isFailure(resp)) {
      setIsLoadingOfferHistory(false);
      return false;
    }
    const getResp = await props.getOfferHistoryList(id);
    await props.getAuthorizationSummaryAddress(id); // Needed to refresh
    await props.getAuthDestinationServices(id); // Needed to refresh possible destination services status

    if (isFailure(getResp)) {
      setIsLoadingOfferHistory(false);
      return false;
    }
    offerRows = createOfferRows(getResp.response || []);
    setIsLoadingOfferHistory(false);
    return true;
  };

  const isValidForMortgageLeadSends = () => {
    return (
      (mortgageLeadInfo?.mortgageLenderSelected === null || mortgageLeadInfo?.mortgageLenderSelected === ZERO_GUID) &&
      selectedMortgageLeadIds.length > 0 &&
      mortgageLeadInfo?.housingStatus !== null &&
      mortgageLeadInfo?.housingStatus !== ZERO_GUID &&
      mortgageLeadInfo?.typeOfRelocation !== null &&
      mortgageLeadInfo?.typeOfRelocation !== ZERO_GUID &&
      mortgageLeadInfo?.closingCostMethod !== null &&
      mortgageLeadInfo?.closingCostMethod !== ZERO_GUID &&
      mortgageLeadInfo?.isDirectBillEligible !== null &&
      mortgageLeadInfo?.isSpanishSpeaking !== null &&
      mortgageLeadInfo?.hasBenefitsCapAmount !== null &&
      (mortgageLeadInfo?.hasBenefitsCapAmount === false ||
        (mortgageLeadInfo?.hasBenefitsCapAmount === true &&
          mortgageLeadInfo?.capAmount !== null &&
          mortgageLeadInfo?.capAmount !== undefined))
    );
  };

  const [isLoadingSendMortgages, setIsLoadingSendMortgages] = useState(false);
  const [openStatusMenu, setOpenStatusMenu] = useState(false);

  const handleSendMortgageLeads = async () => {
    setIsLoadingSendMortgages(true);
    const resp = await sendMortgageLeads(id);
    setIsLoadingSendMortgages(false);
    return resp;
  };

  const SendMortgageLeads = ({ ...rest }) => {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0 10px'
            }}
          >
            {!isLoadingSendMortgages && (
              <Button
                onClick={handleSendMortgageLeads}
                color="secondary"
                disabled={hasSentAnyMortgageLeadLetter || !isValidForMortgageLeadSends()}
                variant="contained"
              >
                Send Mortgage Leads
              </Button>
            )}
            {isLoadingSendMortgages && <SpinnerComponent />}
          </Box>
        </Box>
      </Box>
    );
  };

  const buyerStatusOrder = [
    {
      title: 'Initiated',
      id:
        enumerations && enumerations.buyerStatuses && enumerations.buyerStatuses.length > 0
          ? enumerations.buyerStatuses.find(s => s.title === 'Initiated')?.id
          : '',
      isActive: true,
      date: buyer?.serviceInitiationDate ?? null
    },
    {
      title: 'Agent Vetting',
      id:
        enumerations && enumerations.buyerStatuses && enumerations.buyerStatuses.length > 0
          ? enumerations.buyerStatuses.find(s => s.title === 'Agent Vetting')?.id
          : '',
      isActive: true,
      date: buyer?.agentVettingDate ?? null
    },
    {
      title: 'Active Homefinding',
      id:
        enumerations && enumerations.buyerStatuses && enumerations.buyerStatuses.length > 0
          ? enumerations.buyerStatuses.find(s => s.title === 'Active Homefinding')?.id
          : '',
      isActive: true,
      date: offerHistoryDto && offerHistoryDto.length > 0 ? offerHistoryDto[0].offerHistory.fallThroughDate : null
    },
    {
      title: 'Under Contract',
      id:
        enumerations && enumerations.buyerStatuses && enumerations.buyerStatuses.length > 0
          ? enumerations.buyerStatuses.find(s => s.title === 'Under Contract')?.id
          : '',
      isActive: true,
      date: offerHistoryDto && offerHistoryDto.length > 0 ? offerHistoryDto[0].offerHistory.contractDate : null
    },
    {
      title: 'Closed',
      id:
        enumerations && enumerations.buyerStatuses && enumerations.buyerStatuses.length > 0
          ? enumerations.buyerStatuses.find(s => s.title === 'Closed')?.id
          : '',
      isActive: true,
      date: offerHistoryDto && offerHistoryDto.length > 0 ? offerHistoryDto[0].offerHistory.actualCloseDate : null
    },
    {
      title: 'Canceled',
      id:
        enumerations && enumerations.buyerStatuses && enumerations.buyerStatuses.length > 0
          ? enumerations.buyerStatuses.find(s => s.title === 'Canceled')?.id
          : '',
      isActive: buyerStatus === 'Canceled' ? true : false,
      date: buyer?.serviceCanceledDate ?? null
    },
    {
      title: 'On Hold',
      id:
        enumerations && enumerations.buyerStatuses && enumerations.buyerStatuses.length > 0
          ? enumerations.buyerStatuses.find(s => s.title === 'On Hold')?.id
          : '',
      isActive: buyerStatus === 'On Hold' ? true : false,
      date: buyer?.serviceOnHoldDate ?? null
    },
    {
      title: 'Completed',
      id:
        enumerations && enumerations.buyerStatuses && enumerations.buyerStatuses.length > 0
          ? enumerations.buyerStatuses.find(s => s.title === 'Completed')?.id
          : '',
      isActive: buyerStatus === 'Completed' ? true : false,
      date: buyer?.serviceCompletedDate ?? null
    }
  ];

  return (
    <>
      <Box sx={{ padding: '20px' }}>
        {showComment && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1200,
              pointerEvents: 'none'
            }}
          />
        )}
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Paper
            square
            className={classNames('position-fixed', props.classes.headerFixed, props.classes.container)}
            sx={{
              position: 'sticky',
              paddingRight: '10px',
              paddingLeft: '10px',
              marginBottom: '15px',
              minWidth: '100%'
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px', marginBottom: '10px' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
                <div></div>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingTop: '20px' }}>
                <StatusMenu
                  anchorEl={openStatusMenu}
                  onClose={() => setOpenStatusMenu(false)}
                  currentStatus={currentStatus}
                  statusHeader="Buyer Status"
                  statusList={buyerStatusOrder}
                  statusDates={statuses}
                  classes={props.classes}
                  serviceInitiatedDate={buyer?.serviceInitiationDate || fileServices.addedOn}
                />
                <Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                      Move Type
                    </Typography>
                  </Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    {/* <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                      {details?.authDetails?.summary.moveType}
                    </Typography> */}
                  </Box>
                </Box>
                <Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                      Policy
                    </Typography>
                  </Box>
                  <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                    {/* <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                      {details?.authDetails?.authClientPolicies?.clientPolicyCode}
                    </Typography> */}
                  </Box>
                </Box>
                {type === 'Buyer' && (
                  <Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                        MRES Id:
                      </Typography>
                    </Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                      <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                        {buyer?.morrealeDestinationBuyerFileId ? buyer.morrealeDestinationBuyerFileId : 'N/A'}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
              {location && !location.pathname.includes('expenses') && !isReadOnly && (
                <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
                  <AuthServiceCancellationToggleButton
                    isCancelled={!!buyer?.serviceCanceledDate}
                    serviceName="Destination Buyer"
                    sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                    onServiceCancelled={onCancelService}
                    onServiceReactivated={onReactivateService}
                  />
                  {!buyer?.serviceCanceledDate && (
                    <AuthServiceHoldToggleButton
                      isOnHold={!!buyer?.serviceOnHoldDate}
                      sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                      onSetOnHold={onSetOnHold}
                      onTakeOffHold={takeOffHold}
                    />
                  )}
                  <Button
                    color="secondary"
                    variant="contained"
                    sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                    onClick={onCompleteService}
                  >
                    {' '}
                    Complete Service{' '}
                  </Button>
                  <Button
                    onClick={() => setShowComment(true)}
                    variant="contained"
                    sx={{
                      maxHeight: '40px',
                      marginLeft: '12px',
                      marginTop: '8px',
                      backgroundColor: '#41B7C0',
                      color: 'white',
                      '&:hover': { backgroundColor: '#3d959c' }
                    }}
                  >
                    Comments
                  </Button>
                </Box>
              )}
            </Box>
          </Paper>
        </Grid>
        {/* <DestinationServicesStatusStepper status={currentStatus} allStatuses={currentStatusTypes} /> */}
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          <Grid item xs={12} xl={8} rowSpacing={2}>
            <BuyerPreferencesCard
              authId={props.id}
              buyerDetails={buyer}
              hideEdit={location.pathname.includes('expenses') || isReadOnly}
              enumerations={enumerations}
              type={type}
              brokerAgents={brokerAgents}
              authCommentRegardingTypes={authCommentRegardingTypes}
              authCommentServiceTypes={authCommentServiceTypes}
              emailTemplates={emailTemplates}
              vendors={vendorsPreferredVendorSorted}
              allVendors={vendors}
            />
            <Grid item sx={{ marginBottom: '10px', marginTop: '16px' }}>
              <CreateTripCard
                onSubmit={createTrip}
                onDelete={deleteTrip}
                familyMembers={details?.familyMembers}
                trips={buyerTrips}
                location={location}
                enumerations={enumerations}
                addresses={addressOptions.filter(s => s.excludeAddressFromSelection === false)}
                showToast={showToast}
                classes={props.classes}
                currentTripId={currentTripId}
                setCurrentTripId={setCurrentTripId}
                isReadOnly={location.pathname.includes('expenses') || isReadOnly}
                enforceDateChronology
              />
            </Grid>

            {currentTripId && (
              <>
                <Grid item>
                  <HouseHuntingTripCard
                    trip={trip}
                    familyMembers={familyMembers}
                    travelRequests={(buyerTrips || []).filter(
                      t => t.tripCategoryId === HOME_FINDING_TRIP_CATEGORY_ID || t.tripCategoryId === 'c407ec7e-55bf-4768-bba8-1a0bf58208ed'
                    )}
                    hideEdit={location.pathname.includes('expenses') || isReadOnly}
                    id={id}
                    serviceId={buyer?.buyerServiceId}
                    addresses={addressOptions.filter(s => s.excludeAddressFromSelection === false)}
                    enumerations={props.enumerations}
                    buyer={buyer}
                    type={'Buyer'}
                    enforceDateChronology
                  />
                </Grid>
              </>
            )}
            <Card sx={{ marginTop: '16px' }}>
              <Box>
                <CardContent className={props.classes.cardContainer}>
                  <div className="row justify-space-between align-center">
                    <div className={props.classes.iconRow}>
                      <Tooltip title={'Money'} key={'Destination Services'} placement="right">
                        <FontAwesomeIcon icon={['fas', 'house']} size="2x" />
                      </Tooltip>
                      <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
                        Offer History
                      </Typography>
                    </div>
                  </div>
                </CardContent>
                <CardContent sx={{ padding: '10px', marginLeft: '30px' }}>
                  {!isLoadingOfferHistory && (
                    <CrudTable
                      editingMode={'modal'}
                      columns={offerHistoryColumns}
                      rows={offerRows}
                      createRow={createOfferHistoryRow}
                      updateRow={updateOfferHistoryRow}
                      deleteRow={deleteOfferHistoryRow}
                      customAddText={'Add Offer'}
                      hideEdit={location.pathname.includes('expenses') || isReadOnly}
                      showBasicTable={true}
                    />
                  )}
                  {isLoadingOfferHistory && <Spinner />}
                </CardContent>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} xl={4} rowSpacing={2}>
            {type === 'Buyer' && (
              <EditableCard
                tabs={mortgageLeadsTabs}
                summaries={mortgageLeadsSummaries}
                numColumns={3}
                updateFields={handleUpdateMortgageLeads}
                isLoading={isLoading}
                hideEdit={location.pathname.includes('expenses') || isReadOnly}
                ButtonComponent={SendMortgageLeads}
              />
            )}
            <Box sx={{ marginTop: '16px' }}>
              <AuthServiceGlobalEmailCardComponent
                authId={id}
                communication={details.authorizationDetails}
                emailTemplates={emailTemplates}
                serviceId={SERVICE_IDS.DESTINATION_BUYER_SERVICE_ID}
                authCommentServicesEnum={authCommentServiceTypes}
                authCommentRegardingEnum={authCommentRegardingTypes}
                authSentTemplates={details.sentEmailTemplates}
                history={props.history}
                selectedAuthServiceId={buyerId}
                vendorOptions={vendorOptions}
                allVendorOptions={vendorsPreferredVendorSorted}
                serviceTemplates={validTemplates}
                selectedSegmentServiceId={buyerId}
              />
            </Box>
            <Box sx={{ marginTop: '16px' }}>
              <EditableCard
                tabs={mainCardTabs}
                summaries={mainCardBuyerSummaries}
                numColumns={4}
                updateFields={updateBuyerFields}
                isLoading={isLoading}
                hideEdit={location.pathname.includes('expenses') || isReadOnly}
              />
            </Box>
            <Box sx={{ marginTop: '16px' }}>
              <EstimatedDatesCard
                estimatedDates={destinationInfo.destinationEstimatedDates}
                hideEdit={location.pathname.includes('expenses') || isReadOnly}
                authId={id}
                enforceDateChronology
              />
            </Box>
            {hasClosedOffer && (
              <Box sx={{ marginTop: '16px' }}>
                <EditableCard tabs={revenueTabs} summaries={revenueSummaries} numColumns={3} hideEdit={true} />
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
      {showTriggeredComment && (
        <ServiceTriggeredComment
          authorizationId={props.id}
          serviceOptionId={'946f7f77-2a35-4d86-9b18-616f927f7124'}
          displayText={'Destination - Service Completed Comment'}
          setShowTriggeredComment={setShowTriggeredComment}
        />
      )}
      {showComment && (
        <SlidingCommentsAndNotes
          authorizationId={props.id}
          serviceOptionId={'946f7f77-2a35-4d86-9b18-616f927f7124'}
          setShowComment={setShowComment}
          isOpen={true}
        />
      )}
    </>
  );
};

BuyerServices.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {};
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getAuthorizationSummary,
    getAuthDateSummary,
    getAuthDestinationServices,
    updateAuthDestinationServicesBuyer,
    getBrokerAgents,
    setAuthId,
    setLoadingComplete,
    getBrokerAgentsById,
    getOfferHistoryList,
    postOfferHistoryList,
    updateOfferHistoryList,
    deleteOfferHistoryList,
    getAddress,
    showToast,
    updateAuthDestinationTripsBuyer,
    deleteAuthDestinationTripsBuyer,
    getServiceStatusDates,
    getAuthorizationSummaryAddress
  })
)(BuyerServices);
